export enum CountryCode {
  Andorra = 'AD',
  UnitedArabEmirates = 'AE',
  Afghanistan = 'AF',
  AntiguaAndBarbuda = 'AG',
  Anguilla = 'AI',
  Albania = 'AL',
  Armenia = 'AM',
  Angola = 'AO',
  Antarctica = 'AQ',
  Argentina = 'AR',
  AmericanSamoa = 'AS',
  Austria = 'AT',
  Australia = 'AU',
  Aruba = 'AW',
  Azerbaijan = 'AZ',
  BosniaAndHerzegovina = 'BA',
  Barbados = 'BB',
  Bangladesh = 'BD',
  Belgium = 'BE',
  BurkinaFaso = 'BF',
  Bulgaria = 'BG',
  Bahrain = 'BH',
  Burundi = 'BI',
  Benin = 'BJ',
  Bermuda = 'BM',
  BruneiDarussalam = 'BN',
  Bolivia = 'BO',
  BonaireSintEustatiusAndSaba = 'BQ',
  Brazil = 'BR',
  Bahamas = 'BS',
  Bhutan = 'BT',
  BouvetIsland = 'BV',
  Botswana = 'BW',
  Belarus = 'BY',
  Belize = 'BZ',
  Canada = 'CA',
  CocosKeelingIslands = 'CC',
  DemocraticRepublicOfCongo = 'CD',
  CentralAfricanRepublic = 'CF',
  Congo = 'CG',
  Switzerland = 'CH',
  "Côted'Ivoire" = 'CI',
  CookIslands = 'CK',
  Chile = 'CL',
  CanaryIslands = 'IC',
  Cameroon = 'CM',
  China = 'CN',
  Colombia = 'CO',
  CostaRica = 'CR',
  Cuba = 'CU',
  CaboVerde = 'CV',
  Curaçao = 'CW',
  ChristmasIsland = 'CX',
  Cyprus = 'CY',
  CzechRepublic = 'CZ',
  Germany = 'DE',
  Djibouti = 'DJ',
  Denmark = 'DK',
  Dominica = 'DM',
  DominicanRepublic = 'DO',
  Algeria = 'DZ',
  Ecuador = 'EC',
  Estonia = 'EE',
  Egypt = 'EG',
  Eritrea = 'ER',
  Spain = 'ES',
  Ethiopia = 'ET',
  Finland = 'FI',
  ÅlandIslands = 'AX',
  Fiji = 'FJ',
  FalklandIslandsMalvinas = 'FK',
  FederatedStatesOfMicronesia = 'FM',
  FaroeIslands = 'FO',
  France = 'FR',
  FrenchGuiana = 'GF',
  Guadeloupe = 'GP',
  Martinique = 'MQ',
  Mayotte = 'YT',
  Monaco = 'MC',
  Réunion = 'RE',
  SaintBarthélemy = 'BL',
  SaintMartinFrenchPart = 'MF',
  SaintPierreAndMiquelon = 'PM',
  Gabon = 'GA',
  UnitedKingdomOfGreatBritainAndNorthernIreland = 'GB',
  Grenada = 'GD',
  Georgia = 'GE',
  Guernsey = 'GG',
  Ghana = 'GH',
  Gibraltar = 'GI',
  Greenland = 'GL',
  Gambia = 'GM',
  Guinea = 'GN',
  EquatorialGuinea = 'GQ',
  Greece = 'GR',
  SouthGeorgiaAndTheSouthSandwichIslands = 'GS',
  Guatemala = 'GT',
  Guam = 'GU',
  GuineaBissau = 'GW',
  Guyana = 'GY',
  HongKong = 'HK',
  HeardIslandAndMcDonaldIslands = 'HM',
  Honduras = 'HN',
  Croatia = 'HR',
  Haiti = 'HT',
  Hungary = 'HU',
  Indonesia = 'ID',
  Ireland = 'IE',
  Israel = 'IL',
  IsleOfMan = 'IM',
  India = 'IN',
  BritishIndianOceanTerritory = 'IO',
  Iraq = 'IQ',
  Iran = 'IR',
  Iceland = 'IS',
  Italy = 'IT',
  Jersey = 'JE',
  Jamaica = 'JM',
  Jordan = 'JO',
  Japan = 'JP',
  Kenya = 'KE',
  Kyrgyzstan = 'KG',
  Cambodia = 'KH',
  Kiribati = 'KI',
  Comoros = 'KM',
  SaintKittsAndNevis = 'KN',
  DemocraticPeoplesRepublicOfKorea = 'KP',
  RepublicOfKorea = 'KR',
  Kuwait = 'KW',
  CaymanIslands = 'KY',
  Kazakhstan = 'KZ',
  LaoPeoplesDemocraticRepublic = 'LA',
  Lebanon = 'LB',
  SaintLucia = 'LC',
  Liechtenstein = 'LI',
  SriLanka = 'LK',
  Liberia = 'LR',
  Lesotho = 'LS',
  Lithuania = 'LT',
  Luxembourg = 'LU',
  Latvia = 'LV',
  Libya = 'LY',
  Morocco = 'MA',
  WesternSahara = 'EH',
  Moldova = 'MD',
  Montenegro = 'ME',
  Madagascar = 'MG',
  MarshallIslands = 'MH',
  NorthMacedonia = 'MK',
  Mali = 'ML',
  Myanmar = 'MM',
  Mongolia = 'MN',
  Macao = 'MO',
  NorthernMarianaIslands = 'MP',
  Mauritania = 'MR',
  Montserrat = 'MS',
  Malta = 'MT',
  Mauritius = 'MU',
  Maldives = 'MV',
  Malawi = 'MW',
  Mexico = 'MX',
  Malaysia = 'MY',
  Mozambique = 'MZ',
  Namibia = 'NA',
  NewCaledonia = 'NC',
  Niger = 'NE',
  NorfolkIsland = 'NF',
  Nigeria = 'NG',
  Nicaragua = 'NI',
  Netherlands = 'NL',
  Norway = 'NO',
  SvalbardAndJanMayen = 'SJ',
  Nepal = 'NP',
  Nauru = 'NR',
  Niue = 'NU',
  NewZealand = 'NZ',
  Oman = 'OM',
  Panama = 'PA',
  Peru = 'PE',
  FrenchPolynesia = 'PF',
  PapuaNewGuinea = 'PG',
  Philippines = 'PH',
  Pakistan = 'PK',
  Poland = 'PL',
  Pitcairn = 'PN',
  Palestine = 'PS',
  Portugal = 'PT',
  Palau = 'PW',
  Paraguay = 'PY',
  Qatar = 'QA',
  Romania = 'RO',
  Serbia = 'RS',
  RussianFederation = 'RU',
  Rwanda = 'RW',
  SaudiArabia = 'SA',
  SolomonIslands = 'SB',
  Seychelles = 'SC',
  Sudan = 'SD',
  Sweden = 'SE',
  Singapore = 'SG',
  SaintHelenaAscensionAndTristandaCunha = 'SH',
  Slovenia = 'SI',
  Slovakia = 'SK',
  SierraLeone = 'SL',
  SanMarino = 'SM',
  Senegal = 'SN',
  Somalia = 'SO',
  Suriname = 'SR',
  SouthSudan = 'SS',
  SãoToméAndPríncipe = 'ST',
  ElSalvador = 'SV',
  SintMaartenDutchPart = 'SX',
  SyrianArabRepublic = 'SY',
  Swaziland = 'SZ',
  TurksAndCaicosIslands = 'TC',
  Chad = 'TD',
  FrenchSouthernTerritories = 'TF',
  Togo = 'TG',
  Thailand = 'TH',
  Tajikistan = 'TJ',
  Tokelau = 'TK',
  TimorLeste = 'TL',
  Turkmenistan = 'TM',
  Tunisia = 'TN',
  Tonga = 'TO',
  Turkey = 'TR',
  TrinidadAndTobago = 'TT',
  Tuvalu = 'TV',
  Taiwan = 'TW',
  Tanzania = 'TZ',
  Ukraine = 'UA',
  Uganda = 'UG',
  UnitedStatesMinorOutlyingIslands = 'UM',
  UnitedStatesOfAmerica = 'US',
  PuertoRico = 'PR',
  Uruguay = 'UY',
  Uzbekistan = 'UZ',
  HolySee = 'VA',
  SaintVincentAndTheGrenadines = 'VC',
  Venezuela = 'VE',
  BritishVirginIslands = 'VG',
  USVirginIslands = 'VI',
  VietNam = 'VN',
  Vanuatu = 'VU',
  WallisAndFutuna = 'WF',
  Samoa = 'WS',
  Yemen = 'YE',
  SouthAfrica = 'ZA',
  Zambia = 'ZM',
  Zimbabwe = 'ZW',
}
